import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../ui/table";
import generateAction from "../../../../utils/action-helpers";
import { FILE, MESSAGES } from "../../../../state/actions";
import TooltipButton from "../../../ui/tooltip-button";
import { messageState } from "../../../../utils/messajes";

const FileTable = ({ data, intl }) => {
  const { messages } = intl;
  const [warningVisible, setWarningVisible] = useState(false);
  const toUpload = useRef({});
  const { downloadedKnow, uploadLearningFileData } = useSelector(state => state.files);
  const dispatch = useDispatch();
  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const downloadFile = (file, type) => {
    if (type === "CLIENT_NAMES") {
      dispatch(generateAction(FILE.FETCH_KNOW));
    } else {
      const hiddenElement = document.createElement("a");
      hiddenElement.href = file.blob;
      hiddenElement.target = "_blank";
      hiddenElement.download = file.name;
      hiddenElement.click();
    }
  };

  useEffect(() => {
    dispatch(
      generateAction(
        MESSAGES.UPLOAD_STATUS,
        warningVisible ? messageState.WARNING : messageState.IDLE
      )
    );
  }, [dispatch, warningVisible]);

  useEffect(() => {
    if (downloadedKnow) {
      downloadFile(downloadedKnow);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadedKnow]);

  useEffect(() => {
    if (uploadLearningFileData && toUpload.current.file) {
      const { url, fields } = uploadLearningFileData;
      const formData = new FormData();
      formData.append("key", "learning.xlsx");
      Object.keys(fields).forEach(field => {
        formData.append(field, fields[field]);
      });
      formData.append("file", toUpload.current.file);
      dispatch(
        generateAction(FILE.UPLOAD_LEARNING_FILE, {
          url,
          data: formData
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadLearningFileData]);

  const doClickFileInput = type => () => {
    const el = document.getElementById("fileElem");
    if (el) {
      toUpload.current = { type };
      el.click();
    }
  };

  const uploadFile = () => {
    const el = document.getElementById("fileElem");
    toUpload.current.file = el.files[0];
    const { type, file } = toUpload.current;
    if (type === "CLIENT_NAMES") {
      dispatch(generateAction(FILE.UPLOAD_LEARNING_FILE_DATA));
    } else {
      toBase64(file)
        .then(base64 => {
          dispatch(
            generateAction(FILE.UPLOAD, {
              name: file.name,
              type,
              blob: base64
            })
          );
        })
        .catch(() => setWarningVisible(true));
    }
  };

  const columns = [
    {
      name: "name",
      label: messages.archive,
      options: {
        cellRenderer: item => {
          const { value } = item.cell;
          return value || " - - ";
        }
      }
    },
    {
      name: "type",
      label: messages.type
    },
    {
      name: "updateAt",
      label: messages.updatedDate,
      options: {
        cellRenderer: item => {
          const { value } = item.cell;
          return value || " - - ";
        }
      }
    },
    {
      label: messages.empty,
      options: {
        sort: false,
        filter: false,
        cellRenderer: value => {
          const { original } = value.row;
          return (
            <div className="up-action">
              <input type="file" id="fileElem" style={{ display: "none" }} onChange={uploadFile} />
              <TooltipButton
                type="button"
                buttonClassName="btn-action"
                iconClassName="icono-cloud-upload"
                tooltipText="Subir fichero"
                onClick={doClickFileInput(original.type)}
              />

              <TooltipButton
                type="button"
                buttonClassName="btn-action"
                onClick={() => downloadFile(original, original.type)}
                tooltipText="Descargar fichero"
                iconClassName="icono-cloud-download"
                disabled={!original.name}
              />
            </div>
          );
        }
      }
    }
  ];

  return (
    <div>
      <Table
        placeHolder="Buscar por nombre de archivo..."
        className="files"
        columns={columns}
        data={data}
        options={{ removeDownloadAction: true }}
      />
    </div>
  );
};

FileTable.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({}))
};

FileTable.defaultProps = {
  data: []
};

export default injectIntl(FileTable);
